import { inlineFormValidationOnBlur } from "../global/_inlineFormValidationOnBlur";
// first call for feedback template - builds select dropdown
const feedbackModal = (params, returnHTML) => {
    
    chatFeedbackChoiceBody(returnHTML);

};

// chat | feedback choice body
const chatFeedbackChoiceBody = (returnHTML) => {
    let initialHTML = ''
        initialHTML =   `<div id="feedbackModalStatic">
                            <div id="feedbackLogo"><img src="/assets/img/logos/dillard-logo.svg" alt="Dillard's Logo" width="136" height="30"></div>
                            <div id="feedbackForm">
                                <div class="row m-0" id="choiceChatFeedback">
                                    <div class="col-xs-12 col-12 p-0">
                                        <p class="text-center m-t-15 m-b-20">We value your feedback. Please select an option that best fits your needs:</p>
                                    </div>
                                    <div class="col-xs-12 col-12 p-0">
                                        <div class="row m-0" id="choiceChatFeedbackWrapper">
                                            <div class="col-xs-6 col text-center p-t-15 p-b-15" id="choiceChat">
                                                <svg width="77" height="76" viewBox="0 0 77 76" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="choiceChatIcon">
                                                    <title id='choiceChatIcon'>Chat With Us</title>
                                                    <rect x="0.5" width="76" height="76" rx="38" fill="#F2F2F2"/>
                                                    <g clip-path="url(#choiceChatSVG)">
                                                        <path d="M33.25 38C33.25 38.4641 33.0656 38.9092 32.7374 39.2374C32.4092 39.5656 31.9641 39.75 31.5 39.75C31.0359 39.75 30.5908 39.5656 30.2626 39.2374C29.9344 38.9092 29.75 38.4641 29.75 38C29.75 37.5359 29.9344 37.0908 30.2626 36.7626C30.5908 36.4344 31.0359 36.25 31.5 36.25C31.9641 36.25 32.4092 36.4344 32.7374 36.7626C33.0656 37.0908 33.25 37.5359 33.25 38ZM40.25 38C40.25 38.4641 40.0656 38.9092 39.7374 39.2374C39.4092 39.5656 38.9641 39.75 38.5 39.75C38.0359 39.75 37.5908 39.5656 37.2626 39.2374C36.9344 38.9092 36.75 38.4641 36.75 38C36.75 37.5359 36.9344 37.0908 37.2626 36.7626C37.5908 36.4344 38.0359 36.25 38.5 36.25C38.9641 36.25 39.4092 36.4344 39.7374 36.7626C40.0656 37.0908 40.25 37.5359 40.25 38ZM45.5 39.75C45.9641 39.75 46.4092 39.5656 46.7374 39.2374C47.0656 38.9092 47.25 38.4641 47.25 38C47.25 37.5359 47.0656 37.0908 46.7374 36.7626C46.4092 36.4344 45.9641 36.25 45.5 36.25C45.0359 36.25 44.5908 36.4344 44.2626 36.7626C43.9344 37.0908 43.75 37.5359 43.75 38C43.75 38.4641 43.9344 38.9092 44.2626 39.2374C44.5908 39.5656 45.0359 39.75 45.5 39.75Z" fill="black"/>
                                                        <path d="M28.2887 51.6553L28.3238 51.6483C31.5262 51.013 33.4827 50.1748 34.3927 49.7145C35.7323 50.073 37.1133 50.2531 38.5 50.25C46.2315 50.25 52.5 44.7655 52.5 38C52.5 31.2345 46.2315 25.75 38.5 25.75C30.7685 25.75 24.5 31.2345 24.5 38C24.5 41.08 25.8003 43.8975 27.9475 46.05C27.7978 47.4328 27.4902 48.7938 27.0305 50.1065L27.0252 50.1257C26.8945 50.5017 26.7521 50.8734 26.5982 51.2405C26.46 51.566 26.7278 51.93 27.076 51.874C27.4814 51.8076 27.8857 51.7346 28.2887 51.6553ZM29.6887 46.2162C29.7133 45.96 29.681 45.7016 29.5941 45.4593C29.5073 45.217 29.3681 44.9968 29.1865 44.8145C27.3315 42.9525 26.25 40.569 26.25 38C26.25 32.414 31.507 27.5 38.5 27.5C45.493 27.5 50.75 32.414 50.75 38C50.75 43.586 45.493 48.5 38.5 48.5C37.2663 48.503 36.0377 48.343 34.846 48.024C34.4295 47.9124 33.9864 47.9585 33.6018 48.1535C32.9245 48.4965 31.4317 49.151 28.9922 49.7162C29.3323 48.5737 29.5655 47.402 29.6887 46.2162Z" fill="black"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="choiceChatSVG">
                                                        <rect width="28" height="28" fill="white" transform="translate(24.5 24)"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <p class="m-t-10 m-b-10 p-0">Chat now with a Dillard's representative.</p>
                                                <button class="btn btn-secondary btn-block" onclick="openChatButtonClick();" onkeypress="openChatButtonClick();" data-dismiss="modal" data-target="feedback-modal">Chat With Us</button>
                                            </div>
                                            <div class="col-xs-6 col text-center p-t-15 p-b-15" id="choiceFeedback">
                                                <svg width="77" height="76" viewBox="0 0 77 76" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="choiceFeedbackIcon">
                                                    <title id="choiceFeedbackIcon">Leave Feedback</title>
                                                    <rect x="0.5" width="76" height="76" rx="38" fill="#F2F2F2"/>
                                                    <g clip-path="url(#choiceFeedbackSVG)">
                                                        <path d="M27.796 26.069C26.362 25.7105 25.03 26.795 24.934 28.199C24.826 29.7755 24.589 31.223 24.292 32.084C24.1045 32.624 23.5735 33.6035 22.732 34.5425C21.8965 35.477 20.809 36.3095 19.5355 36.6575C18.5275 36.932 17.5 37.805 17.5 39.08V45.0815C17.5 46.349 18.523 47.2775 19.672 47.399C21.277 47.57 22.018 48.0215 22.774 48.4835L22.846 48.5285C23.254 48.776 23.713 49.0505 24.301 49.2545C24.8965 49.4585 25.5925 49.58 26.5 49.58H31.75C33.1555 49.58 34.1485 48.8645 34.651 47.984C34.8939 47.5685 35.0251 47.0972 35.032 46.616C35.032 46.388 34.9975 46.148 34.9165 45.92C35.218 45.5255 35.4865 45.053 35.6485 44.5685C35.8135 44.0735 35.9065 43.4255 35.6545 42.845C35.758 42.65 35.8345 42.4415 35.893 42.2405C36.0085 41.8355 36.0625 41.3885 36.0625 40.955C36.0625 40.523 36.0085 40.0775 35.893 39.671C35.8417 39.4837 35.7724 39.3019 35.686 39.128C35.9487 38.7543 36.1176 38.323 36.1787 37.8703C36.2398 37.4177 36.1912 36.9569 36.037 36.527C35.728 35.639 35.014 34.877 34.237 34.619C32.9665 34.196 31.5325 34.205 30.463 34.3025C30.241 34.3226 30.0194 34.3476 29.7985 34.3775C30.3167 32.1489 30.2848 29.8276 29.7055 27.614C29.6043 27.2594 29.4103 26.9382 29.1434 26.6837C28.8765 26.4293 28.5465 26.2507 28.1875 26.1665L27.796 26.069ZM31.75 48.0815H26.5C25.735 48.0815 25.2055 47.978 24.79 47.8355C24.3685 47.69 24.031 47.4935 23.626 47.246L23.566 47.21C22.7335 46.7015 21.769 46.1135 19.831 45.908C19.3315 45.854 19 45.473 19 45.083V39.08C19 38.699 19.339 38.2655 19.93 38.105C21.5725 37.655 22.8955 36.611 23.851 35.543C24.8035 34.478 25.447 33.3305 25.708 32.576C26.0725 31.526 26.3185 29.924 26.431 28.301C26.4685 27.758 26.971 27.41 27.4315 27.524L27.8245 27.623C28.0645 27.683 28.2115 27.8375 28.2565 28.0055C28.8691 30.3395 28.7935 32.8009 28.039 35.093C27.9963 35.2205 27.9886 35.3571 28.0168 35.4886C28.045 35.62 28.108 35.7415 28.1993 35.8402C28.2905 35.939 28.4066 36.0114 28.5354 36.0499C28.6642 36.0884 28.801 36.0915 28.9315 36.059L28.936 36.0575L28.957 36.053L29.044 36.032C29.557 35.9234 30.0759 35.8448 30.598 35.7965C31.5925 35.7065 32.7835 35.7155 33.763 36.0425C34.0255 36.1295 34.438 36.4925 34.618 37.0175C34.7785 37.4795 34.7485 38.0225 34.219 38.5505L33.6895 39.08L34.219 39.611C34.2835 39.6755 34.3765 39.8225 34.45 40.0835C34.522 40.334 34.5625 40.6385 34.5625 40.955C34.5625 41.273 34.522 41.576 34.45 41.828C34.375 42.089 34.2835 42.236 34.219 42.3005L33.6895 42.83L34.219 43.361C34.2895 43.4315 34.3825 43.6265 34.2265 44.093C34.065 44.5459 33.8065 44.958 33.469 45.3005L32.9395 45.83L33.469 46.361C33.478 46.3685 33.5305 46.436 33.5305 46.616C33.5217 46.8357 33.4594 47.0499 33.349 47.24C33.1015 47.672 32.5945 48.0815 31.75 48.0815Z" fill="black"/>
                                                    </g>
                                                        <path d="M51.796 49.511C50.362 49.871 49.0315 48.785 48.934 47.381C48.826 45.806 48.589 44.3585 48.292 43.496C48.1045 42.956 47.5735 41.978 46.732 41.039C45.8965 40.103 44.809 39.2705 43.5355 38.924C42.5275 38.648 41.5 37.775 41.5 36.5V30.5C41.5 29.2325 42.523 28.304 43.672 28.181C45.277 28.0115 46.018 27.5585 46.774 27.0965L46.846 27.053C47.254 26.804 47.713 26.5295 48.301 26.327C48.8965 26.12 49.5925 26 50.5 26H55.75C57.1555 26 58.1485 26.717 58.651 27.596C58.897 28.0265 59.032 28.5065 59.032 28.9655C59.032 29.1935 58.9975 29.4335 58.9165 29.6615C59.218 30.0545 59.4865 30.527 59.6485 31.0115C59.8135 31.5065 59.9065 32.1545 59.6545 32.7365C59.758 32.9315 59.8345 33.1385 59.893 33.341C60.0085 33.746 60.0625 34.1915 60.0625 34.625C60.0625 35.0585 60.0085 35.504 59.893 35.909C59.8405 36.089 59.773 36.275 59.686 36.4535C60.277 37.31 60.313 38.2535 60.037 39.053C59.728 39.941 59.014 40.703 58.237 40.961C56.9665 41.3855 55.5325 41.375 54.463 41.2775C54.241 41.2574 54.0194 41.2324 53.7985 41.2025C54.3194 43.4314 54.2875 45.7538 53.7055 47.9675C53.4985 48.7295 52.8805 49.2395 52.1875 49.4135L51.796 49.511ZM55.75 27.5H50.5C49.735 27.5 49.2055 27.602 48.79 27.7445C48.3685 27.89 48.031 28.088 47.626 28.334L47.566 28.3715C46.7335 28.8785 45.769 29.4665 43.831 29.6735C43.3315 29.726 43 30.1085 43 30.4985V36.5C43 36.8825 43.339 37.3145 43.93 37.475C45.5725 37.925 46.8955 38.9705 47.851 40.0385C48.8035 41.1035 49.447 42.251 49.708 43.004C50.0725 44.054 50.3185 45.656 50.431 47.279C50.4685 47.822 50.971 48.1715 51.4315 48.056L51.8245 47.9585C52.0645 47.8985 52.2115 47.7425 52.2565 47.576C52.8694 45.2415 52.7938 42.7795 52.039 40.487C51.9966 40.3596 51.9893 40.2232 52.0176 40.092C52.046 39.9607 52.109 39.8395 52.2002 39.741C52.2914 39.6425 52.4074 39.5702 52.536 39.5318C52.6646 39.4933 52.8012 39.4901 52.9315 39.5225H52.936L52.957 39.5285L53.044 39.548C53.557 39.6566 54.0759 39.7352 54.598 39.7835C55.5925 39.8735 56.7835 39.8645 57.763 39.539C58.0255 39.4505 58.438 39.0875 58.618 38.5625C58.7785 38.1005 58.7485 37.5575 58.219 37.031L57.6895 36.5L58.219 35.969C58.2835 35.906 58.3765 35.759 58.45 35.4965C58.522 35.246 58.5625 34.9415 58.5625 34.625C58.5625 34.3085 58.522 34.004 58.45 33.7535C58.375 33.4925 58.2835 33.344 58.219 33.281L57.6895 32.75L58.219 32.219C58.2895 32.1485 58.3825 31.955 58.2265 31.487C58.0648 31.0347 57.8063 30.6231 57.469 30.281L56.9395 29.75L57.469 29.219C57.478 29.2115 57.5305 29.144 57.5305 28.964C57.5215 28.7448 57.4592 28.5312 57.349 28.3415C57.1 27.908 56.5945 27.5 55.75 27.5Z" fill="black"/>
                                                    <defs>
                                                        <clipPath id="choiceFeedbackSVG">
                                                            <rect width="24" height="24" fill="white" transform="translate(14.5 26)"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <p class="m-t-10 m-b-10 p-0">Leave feedback about your shopping experience.</p>
                                                <button class="btn btn-secondary btn-block" id="leaveFeedbackBtn">Leave Feedback</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`;
	returnHTML(initialHTML);
    handleLeaveFeedbackClick(returnHTML);

    //hide chat choice on payment page
    if ($('.card.active#step2').length) {
        $('#choiceChat').addClass('d-none');
    }
    
    $('#dynamicModalContainer').addClass('feedback-modal');
    $('.modal-dialog').addClass('feedback-modal-dialog');
    $('.modal-content').addClass('feedback-modal-content');
    $('.modal-header').addClass('feedback-modal-header');
};

// modal body
const feedbackModalBody = (returnHTML, topicSelect) => {
    let initialHTML = ''
        initialHTML =   `<div id="feedbackModalStatic">
                            <div id="feedbackLogo"><img src="/assets/img/logos/dillard-logo.svg" alt="Dillard's Logo" width="136" height="30"></div>
                            <form id="feedbackForm">
                                <input type="hidden" class="feedback-form-data meta-data" id="templateId" name="templateId" value="">
                                <input type="hidden" class="feedback-form-data meta-data" id="version" name="version" value="">
                                <input type="hidden" class="feedback-form-data meta-data" id="QuantumMetricSessionID" name="QuantumMetricSessionID" value="">
	                            ${topicSelect}
                                <div id="responseContent">
                                </div>
                                <div id="formActions" class="feedback_buttons_section">
                                   
                                </div>
                            </form>
                        </div>`;
    returnHTML(initialHTML);    

    $('#dynamicModalContainer').addClass('feedback-modal');
    $('.modal-dialog').addClass('feedback-modal-dialog');
    $('.modal-content').addClass('feedback-modal-content');
    $('.modal-header').addClass('feedback-modal-header');
    
    handleTopicSelectChange();
};

// handle the topic select change
const handleTopicSelectChange = () => {
	document.getElementById('feedback_select_input')?.addEventListener('change', updateModalBodyContent);
};

// handle leave feedback choice button click
const handleLeaveFeedbackClick = (returnHTML) => { 
    document.getElementById('leaveFeedbackBtn').addEventListener('click', function(e) {
        ajaxCallFeedback(returnHTML);
    });
};

// feedback ajax call
const ajaxCallFeedback = (returnHTML) => {
    $.ajax({
        url: '/wcs/resources/store/301/survey/template/feedback',
        type: 'GET',
        dataType: 'json',
        success: function (json) {
            let feedbackTemplate = json;
            if (feedbackTemplate !== undefined) {
                let templates = feedbackTemplate.response.templates;
                let topicSelect = '';
                    topicSelect +=     `<div id="feedbackTopic" class="feedback-form-group">
                                            <p>What would you like to tell us about?</p>
                                            <label for="feedback_select_input" class="sr-only">Please select a topic</label>
                                            <select id="feedback_select_input" disabled class="form-control" name="feedback_select_input" required">
                                                <option value="default"  id="selectOption" selected="selected">Please Select an Option</option>`;
                                                for (let x = 0; x < templates.length; x++) {
                                                    let option = document.createElement('option');
                                                    option.innerHTML = templates[x].name;
                                                    option.value = templates[x].templateId + '/' + templates[x].latestVersion;
                                                    topicSelect += option.outerHTML;
                                                }
                    topicSelect +=         `</select>
                                        </div>`
                feedbackModalBody(returnHTML, topicSelect);                
            }
        },
        error: function (json) {
            $('#dynamicModalContainer').modal('hide');
        },
    });
    setTimeout(() => document.getElementById('feedback_select_input')?.removeAttribute('disabled'), 1000)
}

let storeListGlobal;
let qstText;
// second call to update modal content with selected template data
const updateModalBodyContent = (event) => {
    const deviceType = $('body').hasClass("mobilePage") ? 'mobile' : $('body').hasClass('tabletPage') ? 'tablet' : 'desktop';
    let templateIdAndVersion = event.target.value;
    const templateId = templateIdAndVersion.split('/')[0];
    document.getElementById('templateId').value = templateId;
    let version = templateIdAndVersion.split('/')[1];
    document.getElementById('version').value = version;
    if (templateId != "default") {
        let quantumMetricSessionId = document.cookie.match('QuantumMetricSessionID' + '=(.*?)(;|$)');
        quantumMetricSessionId = (quantumMetricSessionId) ? unescape(quantumMetricSessionId[1]) : undefined;
        if (quantumMetricSessionId) {
            document.getElementById('QuantumMetricSessionID').value = quantumMetricSessionId;
        }
        $.ajax({
            url: '/wcs/resources/store/301/survey/template/' + templateIdAndVersion,
            type: 'GET',
            dataType: 'json',
            success: function (json) {
                let newTemplate = json.response;
                if (newTemplate !== undefined) {
                    let newContent = '';
                    let questions = newTemplate.questions;
                    for (let x = 0; x < questions.length; x++) {
                        let question = questions[x];
                        if (question.type === 'LONG') {
                            let questionText = question.text;
                            let isRequired = question.required === true ? 'required' : 'optional';
                            newContent += `<div id="feedbackMessageLong" class="feedback-form-group">
                                                <label for="feedback_textarea" class="sr-only">Enter your message</label>
                                                <textarea id="feedback_textarea" class="form-control feedback-form-data inline-focus" data-validate="required,long" value placeholder="${questionText}${isRequired === 'required' ? '*' : ''}" name="feedback_textarea" maxlength="1000" aria-describedby="" ${isRequired}></textarea>
                                                <div id="characterCounter" class=""><span id="charCountLong">1000 characters remaining</span></div>
                                                <p hidden class="required feedback-error-message">This field is required</p>
                                            </div>
                                            `
                        }
                        if (question.type === 'SHORT') {
                            let questionText = question.text;
                            let isRequired = question.required === true ? 'required' : 'optional';
                            newContent += `<div id="feedbackMessageShort" class="feedback-form-group">
                                                <label for="feedbackTextAreaShort" class="sr-only">Enter your message</label>
                                                <input id="feedbackTextAreaShort" data-validate  class="form-control feedback-form-data feedback-short-ans" value placeholder="${questionText}${isRequired === 'required' ? '*' : ''}" name="feedbackTextAreaShort" maxlength="200" aria-describedby="" ${isRequired}></input>
                                                <div id="characterCounter" class=""><span id="charCountShort">200 characters remaining</span></div>
                                                <p hidden class="required feedback-error-message">This field is required</p>
                                            </div>
                                            `
                        }
                        if (question.type === 'OPT') {
                            let questionText = question.text;
                            let isRequired = question.required === true ? 'required' : 'optional';
                            let questionId = question.questionId;
                            let questionOptions = question.questionOptions;
                            newContent += `<div id="feedbackOptions" class="feedback-form-group">
                                            <label for="feedbackOptionSelect" class="sr-only">Please make a selection</label>
                                            <select id="feedbackOptionSelect" key-selector="${questionId}" data-validate  class="form-control feedback-form-data feedback-options" value name="feedbackOptionSelect" ${isRequired}>
                                                <option value="" selected disabled>${questionText}${isRequired === 'required' ? '*' : ''}</option>`
                                                for (let x = 0; x < questionOptions.length; x++) {
                                                    let option = document.createElement('option');
                                                    option.innerHTML = questionOptions[x].value;
                                                    option.value = questionOptions[x].value;
                                                    newContent += option.outerHTML;
                                                }
                            newContent += `</select>
                                        <p hidden class="required feedback-error-message">This field is required</p>
                                        </div>
                                        `
                        }
                        if (question.type === 'NY') {
                            let questionText = question.text;
                            let isRequired = question.required === true ? 'required' : 'optional';
                            newContent += `<div id="formActions" class="feedback-form-group" ${isRequired}>
                                                <input type="hidden" id="yesNoFeedbackFormInput" key-selector="${x}" data-validate  class="feedback-form-data" name="noYesFeedbackFormInput_${x}" value="" ${isRequired}>
                                                <p>${questionText}${isRequired === 'required' ? '*' : ''}</p>
                                                <button name='yOn' type="button" id="yes" key-selector="${x}" class="btn btn-secondary yesOrNoButton ${x}" value='N'>No</button>
                                                <button name='yOn' type="button" id="no" key-selector="${x}" class="btn btn-secondary yesOrNoButton ${x}" value='Y'>Yes</button>
                                                <p hidden class="required feedback-error-message">This field is required</p>    
                                            </div>
                                            `
                        }
                        if (question.type === 'YN') {
                            let questionText = question.text;
                            let isRequired = question.required === true ? 'required' : 'optional';
                            newContent += `<div id="formActions" class="feedback-form-group" ${isRequired}>
                                                <input type="hidden" id="yesNoFeedbackFormInput" key-selector="${x}" data-validate class="feedback-form-data" name="yesNoFeedbackFormInput_${x}" value="" ${isRequired}>
                                                <p>${questionText}${isRequired === 'required' ? '*' : ''}</p>
                                                <button name='yOn' type="button" id="yes" key-selector="${x}" class="btn btn-secondary yesOrNoButton ${x}" value='Y'>Yes</button>
                                                <button name='yOn' type="button" id="no" key-selector="${x}" class="btn btn-secondary yesOrNoButton ${x}" value='N'>No</button>
                                                <p hidden class="required feedback-error-message">This field is required</p>
                                            </div>
                                            `
                        }
                        if (question.type === 'STAR') {
                            let questionText = question.text;
                            let isRequired = question.required === true ? 'required' : 'optional';
                            newContent += `<div id="feedbackRating" class="feedback-form-group" ${isRequired}> 
                                                <input type="hidden" id="starRating" data-validate class="feedback-form-data inline-focus" name="starRating" value="" ${isRequired}>
                                                <p class="feedback_text" id="star_text">${questionText}${isRequired === 'required' ? '*' : ''}</p>
                                                <button class="star_rating_button" type='button'>
                                                    <span class="feedbackStar star-1" data-star="1">&#9733;</span>
                                                </button>
                                                <button type='button' class="star_rating_button">
                                                    <span class="feedbackStar star-2" data-star="2">&#9733;</span>
                                                </button>
                                                <button type='button' class="star_rating_button">
                                                    <span class="feedbackStar star-3" data-star="3">&#9733;</span>
                                                </button>
                                                <button type='button' class="star_rating_button">
                                                    <span class="feedbackStar star-4" data-star="4">&#9733;</span>
                                                </button>
                                                <button type='button' class="star_rating_button">
                                                    <span class="feedbackStar star-5" data-star="5">&#9733;</span>
                                                </button>
                                                <p class="feedback_text">1 = poor, 5 = excellent</p>
                                                <p hidden class="required feedback-error-message">This field is required</p>
                                            </div>
                                            `
                        }
                        if (question.type === 'EMAIL') {
                            let questionText = question.text;
                            let isRequired = question.required === true ? 'required' : 'optional';
                            newContent += `<div id="feedbackEmail" class="feedback-form-group">
                                                <label for="feedbackEmailInput" class="sr-only">Please enter an email address</label>
                                                <input type="email" id="feedbackEmailInput" class="form-control feedback-form-data inline-focus" data-validate="email,optional" name="feedbackEmailInput" value placeholder="${deviceType === 'desktop' ? questionText : 'Please enter your contact email'}" maxlength="50" ${isRequired}>
                                                <p hidden class="required feedback-error-message">This field is required</p>
                                            </div>
                                            `
                        }
                        if (question.type === 'STORE') {
                            const questionText = question.text;
                            const isRequired = question.required === true ? 'required' : 'optional';
                            const allStores = question.storeList;
                            const stateList = []
                            storeListGlobal = allStores;
                            qstText = questionText;
                            allStores.length && allStores.forEach((store) => {
                                if (!stateList.includes(store.stateName)) {
                                    stateList.push(store.stateName);
                                }
                            });


                            newContent += `<div id="feedbackStoreLocationSelect">
                                            <div class="feedback-form-group">
                                            <label for="feedbackStateSelect" class="sr-only">Please select a state${isRequired === 'required' ? '*' : ''}</label>
                                            <select type='state' id="feedbackStateSelect" class="form-control feedback-form-data location" name="feedbackStateSelect" value='' ${isRequired}>
                                                <option value="*" selected hidden disabled>Select a state${isRequired === 'required' ? '*' : ''}</option>`
                                                stateList.forEach((a) => {
                                                    newContent += `<option value="${a}">${a}</option>`;
                                                })
                            newContent += `</select>
                                            <p hidden class="required feedback-error-message">This field is required</p>
                                            </div>
                                            `
                            newContent += `<div class="feedback-form-group" id='select-store-type' hidden>
                                            <label for="feedbackStoreSelect" class="sr-only">Please select a store${isRequired === 'required' ? '*' : ''}</label>
                                            <select type='store' id="feedbackStoreSelect" class="form-control feedback-form-data location" name="feedbackStoreSelect" value='' ${isRequired}>`
                            newContent += `</select>
                                            <p hidden class="required feedback-error-message">This field is required</p>
                                            </div>
                                            
                                        </div>`
                        }
                    }
                    // inserting new content into modal
                    let newContentNode = document.createElement('div');
                    newContentNode.id = 'responseContent';
                    newContentNode.innerHTML = newContent;
                    let oldContentNode = document.getElementById('responseContent');
                    oldContentNode.parentNode.replaceChild(newContentNode, oldContentNode);
                    listenForStateSelectChange();
                    countCharacters();
                    handleStarRating();
                    handleYesNos();
                    listenForStoreSelectChange();
                    listenForInput();
                    listenForOptionsSelect();
                    listenForOpenClose();
                    let buttons = `<button type="button" id="close-feedback-modal" class="btn btn-secondary form-control" data-dismiss="modal">Cancel</button>
                                   <button type="button" onclick class="btn btn-primary form-control oneClickOnly clickSubmit" id="submit-feedback-form">Submit</button>`
                    document.getElementById("formActions").innerHTML = buttons
                    handleSubmitButton();
                    inlineFormValidationOnBlur();
                }
            },
            error: function (json) {
                $('#dynamicModalContainer').modal('hide');
            },
        });
    } else {
        document.getElementById("responseContent").innerHTML = '';
        document.getElementById("formActions").innerHTML = ''; 
    }
};

const listenForOpenClose = () => {
    if (document.getElementById("close-feedback-modal")) {
        document.getElementById('close-feedback-modal').addEventListener('click', closeFeedbackModal);
    }
    if (document.getElementById("feedback-continue-shopping")) {
        document.getElementById("feedback-continue-shopping").addEventListener('click', closeFeedbackModal)
    }
}

const listenForContinueShoppingButton = () => {
    const continueButton = document.getElementById("feedback-continue-shopping")
    if (continueButton) {
        continueButton.addEventListener('click', closeFeedbackModal)
    }
}

const closeFeedbackModal = () => {
    $('#dynamicModalContainer').modal('hide');
}


// ---------------
// -----STATE-----
//
// handle showing the appropriate optgroup based on selected state name
const listenForStateSelectChange = () => {
   
	if (document.getElementById('feedbackStateSelect')) {
		document.getElementById('feedbackStateSelect').addEventListener('change', showSelectedOptgroup);
	}
};

// dynamically build option list based on state selection
const showSelectedOptgroup = (event) => {
    const errElm = $('#feedbackStateSelect').siblings('.feedback-error-message')[0]; 
    $('#feedbackStateSelect').parent().removeClass('has-error');
    errElm.setAttribute('hidden', '');
    if ($('#feedbackStateSelect').val()) {
        $('#select-store-type').removeAttr('hidden')
    }

    $('#feedbackStoreSelect').not(':first').empty();

    let selectedState = event.target.value;
    
    const storesOfSelectedState = storeListGlobal.filter((a) => {
        return a.stateName === selectedState;
    })

    const dirtyAreas = [];
    storesOfSelectedState.length && storesOfSelectedState.forEach((store) => {
        if (!dirtyAreas.includes(store.marketTag)) {
            dirtyAreas.push(store.marketTag)
        }
    });

    const storesDropdown = document.getElementById('feedbackStoreSelect')
    const cleanAreas = (word) => {
        if (word.includes('\|')) {
        return word.substring(0, word.indexOf('\|'));
        } else return word;
    };

    let optionList = `<option value="*" selected hidden disabled>${qstText}${"*"}</option>`;
    
    dirtyAreas.forEach((a) => {
        let optGrp = `<optgroup label="${cleanAreas(a)}">`;

        storesOfSelectedState.map((b) => {
            if (b.marketTag.includes(a)) {
                optGrp += `<option class="${b.stateName} select-location-option" value="${b.identifier}">${b.name}</option>`;
            }
        });
        
        optGrp += `</optgroup>`;
        optionList += optGrp;
    })

    storesDropdown.innerHTML = optionList;
    
};
// -------------
// -------------



// -------------
// ----STORE----
//
// listen for change on store select option
const listenForStoreSelectChange = () => {
    if (document.getElementById('feedbackStoreSelect')) {
		document.getElementById('feedbackStoreSelect').addEventListener('change', handleStoreErrors);
	}
}

// remove errors on select change
const handleStoreErrors = () => {
    const errElm = $('#feedbackStoreSelect').siblings('.feedback-error-message')[0]; 
    errElm.setAttribute('hidden', '');
    $('#feedbackStoreSelect').parent().removeClass('has-error');
}
//---------------
// --------------


// listen for input on short answers to remove errors
const listenForInput = () => {
    const shortAns = document.getElementsByClassName('feedback-short-ans');

    // idk what i was thinking when I wrote this...refactor at your own discretion
   
    if (shortAns) {
        for (let i = 0; i < shortAns.length; i++) {
            if (shortAns[i] !== undefined) {
                shortAns[i].addEventListener('input change', handleInputErrors);
            }
        } 
	}

    $('.feedback-form-data').on('input change', handleInputErrors);
   
}

const handleInputErrors = (e) => {
    const currElm = e.target;
    $(currElm).parent().removeClass("has-error");
    const errElm = $(currElm).siblings(".feedback-error-message")[0];
    errElm.setAttribute('hidden', '')
}


// listen to select change for options 
const listenForOptionsSelect = () => {
    const options = document.getElementsByClassName('feedback-options');

    if (options) {
        for (let i = 0; i < options.length; i++) {
            if (options[i] !== undefined) {
                options[i].addEventListener('change', handleOptionsErrors);
            }
        }
	}
}

const handleOptionsErrors = (e) => {
    const currElm = e.target;
    $(currElm).parent().removeClass("has-error");
    const errElm = $(currElm).siblings(".feedback-error-message")[0];
    errElm.setAttribute('hidden', '')
}


// star rating - get the selected value and update the hidden input's value
const handleStarRating = () => {
    let allStars = document.querySelectorAll('.feedbackStar');
    const errElm = $('#feedbackRating').children('.feedback-error-message')[0];

    let x = 0;
    while (x < allStars.length) {
        allStars[x].addEventListener('click', function () {
            errElm.setAttribute('hidden', '');
            let currentStar = parseInt(this.getAttribute('data-star'));
            document.getElementById('starRating').value = currentStar;
            let precedingStar = currentStar;
            while (1 <= precedingStar) {
                if (!document.querySelector('.star-' + precedingStar).classList.contains('is-active')) {
                    document.querySelector('.star-' + precedingStar).classList.add('is-active');
                }
                --precedingStar;
            }
            let succeedingStar = currentStar + 1;
            while (5 >= succeedingStar) {
                if (document.querySelector('.star-' + succeedingStar).classList.contains('is-active')) {
                    document.querySelector('.star-' + succeedingStar).classList.remove('is-active');
                }
                ++succeedingStar;
            }
        });
        x++;
    }
}

const countCharacters = () => {
	const feedbackTextAreaLong = document.getElementById('feedback_textarea');
    const feedbackTextAreaShort = document.getElementById('feedbackTextAreaShort');
	const charsRemainingLong = document.getElementById('charCountLong');
    const charsRemainingShort = document.getElementById('charCountShort');
	const maxCharactersLong = 1000;
    const maxCharactersShort = 200;
    if (feedbackTextAreaLong) {
        feedbackTextAreaLong.addEventListener('input', () => {
            $(feedbackTextAreaLong).parent().removeClass('has-error');
            const errElm = $(feedbackTextAreaLong).siblings('.feedback-error-message')[0];
            errElm.setAttribute('hidden', '');
            let numOfCharsLong = feedbackTextAreaLong.value.length;
            let counterLong = maxCharactersLong - numOfCharsLong;
            charsRemainingLong.textContent = counterLong + ' characters remaining';
        });
    }
    if (feedbackTextAreaShort) {
        feedbackTextAreaShort.addEventListener('input', () => {
            $(feedbackTextAreaShort).parent().removeClass('has-error');
            const errElm = $(feedbackTextAreaShort).siblings('.feedback-error-message')[0];
            errElm.setAttribute('hidden', '');
            let numOfCharsShort = feedbackTextAreaShort.value.length;
            let counterShort = maxCharactersShort - numOfCharsShort;
            charsRemainingShort.textContent = counterShort + ' characters remaining';
        });
    }
};

const handleYesNos = () => {
    const fields = document.getElementsByClassName('yesOrNoButton');
    for (let i = 0; i < fields.length; i++) {
        const curButton = fields[i];
        const curFieldInput = $(curButton).siblings('#yesNoFeedbackFormInput')[0];
        const errElm = $(curButton).siblings('.feedback-error-message')[0];
        
        curButton.addEventListener('click', function () {
            $(curButton).parent().removeClass('has-error')
            const clickedValue = $(this).val();
            curFieldInput.value = clickedValue;
            $(curButton).addClass('btn-primary');
            $(curButton).removeClass('btn-secondary');
            errElm.setAttribute('hidden', '');

            const otherElements = $(curButton).siblings();
            for (let r = 0; r < otherElements.length; r++) {
                const curElm = otherElements[r];
                if (curElm instanceof HTMLButtonElement) {
                    $(curElm).removeClass("btn-primary")
                    $(curElm).addClass("btn-secondary")
                }
            }
        })
    }
}


const errorTypesText = {
    invalidEmail: 'Please enter a valid email address.',
    required: 'This field is required.',
    requiredState: 'Please select the state your store is located.',
    requiredStore: 'Please select your store location.',
    requiredFeedback: 'Please enter your feedback.',
    requiredRating: 'Please select a rating.',
    tooLong: 'Response is too long.',
    tooShort: 'Please enter the minimum character amount.',
    invalidResponse: 'Please enter a valid response.',
    requiredSelect: 'Please select a response.'
}


// 

// this is the part where it
const submitActualForm = (dataJason) => {
    const base_url = window.location.origin;

    fetch(base_url + '/wcs/resources/store/301/survey', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataJason)
    },
    ).then((res) => {
        if (res.status === 200) {
            const successView = `<div id='feedback_success_content'>
                                    <div id="feedback_success_title">Thank you!</div>
                                    <div id='feedback_success_message'>We appreciate you taking the time to help make your shopping experience the best it can be.</div>
                                    <button class='btn btn-primary btn-block' onclick id="feedback-continue-shopping" >Continue Shopping</button>
                                </div>`;
            let newContentNode = document.createElement('div');
            newContentNode.id = 'responseContent';
            newContentNode.innerHTML = successView;
            let oldContentNode = document.getElementById('feedbackForm');
            oldContentNode.parentNode.replaceChild(newContentNode, oldContentNode);
            listenForContinueShoppingButton();
        } else {
            const errorView = `<div id="feedback_error_message">Something went wrong, please try again.</div>`;
            let newContentNode = document.createElement('div');
            newContentNode.id = 'responseContent';
            newContentNode.innerHTML = errorView;
            let oldContentNode = document.getElementById('feedbackForm');
            oldContentNode.parentNode.replaceChild(newContentNode, oldContentNode);
        }
    })
    .catch(err => {
        const errorView = `<div id="feedback_error_message">Something went wrong, please try again.</div>`;
        let newContentNode = document.createElement('div');
        newContentNode.id = 'responseContent';
        newContentNode.innerHTML = errorView;
        let oldContentNode = document.getElementById('feedbackForm');
        oldContentNode.parentNode.replaceChild(newContentNode, oldContentNode);
        throw(err);
    })

}



const doSomeSafetyChecks = () => {
    let allFieldsAreValid = true;
    let everythingIsOk = true;
   
    // dynamically add error message of choosing from above
    // show error message 
    const addError = (curField, type) => {
        $(curField).parent().addClass('has-error');
        const errElm = $(curField).siblings('.feedback-error-message')[0];
        errElm.innerHTML = errorTypesText[type];
        $(errElm).removeAttr('hidden', '');
    }

    // otherwise remove it slash hide it
    const removeError = (curField) => {
        $(curField).parent().removeClass('has-error');
        const errElm = $(curField).siblings('.feedback-error-message')[0];
        errElm.setAttribute('hidden', '');
    }

    const validateText = (curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification) => {
        // need to check email type
        const curFieldType = $(curField).attr("type");

        if (curFieldType === 'email') {
            const tooLong = $(curField).val().length >= 50;
            const tooShort = $(curField).val().length <= 3;
            const includesEmailChars = $(curField).val().includes('@') && $(curField).val().includes('.');
            const isValidEmail = (includesEmailChars) && (!tooShort && !tooLong);
            if (!isValidEmail && notEmptyAndNeedsVarification) {
                if (tooLong) {
                    addError(curField, 'tooLong');
                } else if (tooShort) {
                    addError(curField, 'tooShort');
                } else if (!includesEmailChars) {
                    addError(curField, 'invalidEmail')
                } else {
                    addError(curField, 'invalidEmail')
                }
                allFieldsAreValid = false
            } else {
                removeError(curField)
            }
           
        } else if (notEmptyAndNeedsVarification || isEmptyAndNeedsVarification) {
            const length = $(curField).val().length;
            const maxLength = $(curField).attr('maxLength')
            if (length > maxLength) {
                // add class to field, populate p tag
                addError(curField, 'tooLong')
                allFieldsAreValid = false
            } else if (isEmptyAndNeedsVarification) {
                addError(curField, 'required')
                allFieldsAreValid = false
            } else {
               removeError(curField)
            };
        }
    }

    const validateOption = (curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification) => {
        const val = $(curField).val();
        const curFieldType = $(curField).attr("type");

        if (val === null && isEmptyAndNeedsVarification) {
            if (curFieldType === 'state') {
                addError(curField, 'requiredState')
            } else if (curFieldType === 'store') {
                addError(curField, 'requiredStore')
            } else {
                addError(curField, 'requiredSelect')
            }
            allFieldsAreValid = false
        } else {
            removeError(curField)
        }
    }
  
    const validateButtonSelect = (curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification) => {
        const val = $(curField).val();
        const curFieldId = $(curField).attr('id');
        if (val.length === 0 && isEmptyAndNeedsVarification) {
            if (curFieldId === 'starRating') {
                addError(curField, 'requiredRating')
            } else if (curFieldId === 'yesNoFeedbackFormInput') {
                addError(curField, 'requiredSelect')
            } else {
                addError(curField, 'required')
            }
            allFieldsAreValid = false;
        } else {
           removeError(curField)
        }
    }

    const chooseValidationType = (curField) => {
        const curFieldID = $(curField).attr('id');
        const curFieldVal = $(curField).val();
        const curFieldIsSelectType = (curField instanceof HTMLSelectElement);
        const notEmptyAndNeedsVarification = ((curFieldVal !== '' && curFieldVal !== null) && (!$(curField).hasClass('meta-data')));
        const isEmptyAndNeedsVarification = (curField.hasAttribute('required') && ((curFieldVal === '' || curFieldVal === null) && (!$(curField).hasClass('meta-data'))));
        const IDs = {
            'feedback_textarea': function () { validateText(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
            'feedbackTextAreaShort': function () { validateText(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
            'feedbackOptionSelect': function () { validateOption(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
            'yesNoFeedbackFormInput':  function () { validateButtonSelect(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
            'starRating':  function () { validateButtonSelect(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
            'feedbackEmailInput':  function () { validateText(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
            'feedbackStoreSelect':  function () { validateOption(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
            'feedbackStateSelect': function () { validateOption(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
        }
        
        if (curFieldIsSelectType) {
            IDs[curFieldID]();
        } else if (notEmptyAndNeedsVarification || isEmptyAndNeedsVarification) {
            IDs[curFieldID]();
        }
    }

    const fields = document.getElementsByClassName('feedback-form-data');

    const formSubmitDataJason =  {
        userMetadata: {
            QuantumMetricSessionID: ''
        },
        answers: {}
    }; 

    const buildFormData = () => {
        let count = 1;

        for (let i = 0; i < fields.length; i++) {
            const field = $(fields[i]);
            const curFieldType = $(field).attr("type");

            if (($(field).hasClass('meta-data'))) {
               const id = $(field).attr('id')
               const value = $(field).val()
               if (id === 'QuantumMetricSessionID') {
                formSubmitDataJason.userMetadata[id] = value;
               } else {
                formSubmitDataJason[id] = value
               }
            } else if (curFieldType !== 'state') {
                const value = $(fields[i]).val()
                formSubmitDataJason.answers[count] = value;
                count++;
            }
        }
        return formSubmitDataJason;
    }

    for (let i = 0; i < fields.length; i++) {
        const curField = fields[i];
        chooseValidationType(curField)
    }

    if (allFieldsAreValid && everythingIsOk) {
        const submitButton = document.getElementById('submit-feedback-form');
        $(submitButton).attr('disabled', true)
        submitActualForm(buildFormData());
    } 

}


const handleSubmitButton = () => {
    const submitButton = document.getElementById('submit-feedback-form');
    submitButton.addEventListener('click', function (e) {
        e.preventDefault()
        doSomeSafetyChecks()
    })
}




export { feedbackModal };
